import React from "react";
import "./styles.scss";

export default function Toggle(props) {
  const { firstLabel, secondLabel, checkedValue, handleOnChange } = props;
  return (
    <div className="d-flex justify-content-center mb-4">
      <p className="align-self-center mr-2">{firstLabel}</p>
      <label className="switch align-self-center">
        <input
          type="checkbox"
          checked={checkedValue}
          onChange={handleOnChange}
        />
        <span className="slider round"></span>
      </label>
      <p className="align-self-center ml-2">{secondLabel}</p>
    </div>
  );
}
